import { jsx } from "react/jsx-runtime";
import { TextPart } from "./TextPart.js";
import { AnalyzeQueryPart } from "./AnalyzeQueryPart.js";
import { SearchProductsPart } from "./SearchProductsPart.js";
import { FilterResultsPart } from "./FilterResultsPart.js";
import { OrganizeResultsPart } from "./OrganizeResultsPart.js";
import { DataSectionPart } from "./DataSectionPart.js";
import { DailyDealsPart } from "./DailyDealsPart.js";
import { DataSurveySectionPart } from "./DataSurveySectionPart.js";
import { SurveysPart } from "./SurveysPart.js";
import { StoreLocatorPart } from "./StoreLocatorPart.js";
import { ProductDetailsPart } from "./ProductDetailsPart.js";
import { CompareProductsPart } from "./CompareProductsPart.js";
import { FeaturedProductPart } from "./FeaturedProductPart.js";
import { DataFeaturedProductPart } from "./DataFeaturedProductPart.js";
function ConciergePartItem({
  part,
  allParts,
  productMetadataMap,
  onProductClick,
  isStreaming,
  pdpStacklineSku,
  apiBaseUrl
}) {
  var _a, _b, _c;
  switch (part.type) {
    case "file":
      if (((_a = part.mediaType) == null ? void 0 : _a.startsWith("image/")) && part.url) {
        return /* @__PURE__ */ jsx("div", { className: "tw:flex tw:justify-end tw:w-full tw:mb-2", children: /* @__PURE__ */ jsx("div", { className: "tw:max-w-[70%]", children: /* @__PURE__ */ jsx(
          "img",
          {
            src: part.url,
            alt: part.filename || "Uploaded image",
            className: "tw:w-full tw:max-h-[400px] tw:object-cover tw:block tw:rounded-xl"
          }
        ) }) });
      }
      if (part.url) {
        return /* @__PURE__ */ jsx(
          "a",
          {
            href: part.url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "tw:text-sm tw:underline tw:text-blue-600",
            children: part.filename || "Attached file"
          }
        );
      }
      return null;
    case "text":
      return /* @__PURE__ */ jsx(
        TextPart,
        {
          text: part.text || "",
          productMetadataMap,
          onProductClick
        }
      );
    case "tool-analyze_query":
      return /* @__PURE__ */ jsx(AnalyzeQueryPart, { part });
    case "tool-search_products":
      if ((_b = part.input) == null ? void 0 : _b.silent) return null;
      if (allParts.some((p) => p.type === "tool-compare_products")) return null;
      return /* @__PURE__ */ jsx(
        SearchProductsPart,
        {
          part,
          allParts,
          onProductClick,
          isStreaming
        }
      );
    case "tool-filter_results":
      return /* @__PURE__ */ jsx(FilterResultsPart, { part });
    case "tool-organize_results":
      return /* @__PURE__ */ jsx(
        OrganizeResultsPart,
        {
          part,
          allParts,
          productMetadataMap
        }
      );
    case "data-section":
      return /* @__PURE__ */ jsx(DataSectionPart, { part, productMetadataMap });
    case "tool-get_daily_deals":
      return /* @__PURE__ */ jsx(DailyDealsPart, { part, onProductClick });
    case "data-survey-section":
      return /* @__PURE__ */ jsx(DataSurveySectionPart, { part });
    case "tool-get_surveys":
      return /* @__PURE__ */ jsx(SurveysPart, { part, allParts });
    case "tool-show_store_locator":
      return /* @__PURE__ */ jsx(StoreLocatorPart, { part, apiBaseUrl });
    case "tool-get_product_details":
      if ((_c = part.input) == null ? void 0 : _c.silent) return null;
      return /* @__PURE__ */ jsx(ProductDetailsPart, { part, onProductClick, pdpStacklineSku });
    case "tool-compare_products":
      return /* @__PURE__ */ jsx(CompareProductsPart, { part });
    case "tool-show_featured_product":
      return /* @__PURE__ */ jsx(FeaturedProductPart, { part, allParts, productMetadataMap, pdpStacklineSku });
    case "data-featured-product":
      return /* @__PURE__ */ jsx(DataFeaturedProductPart, { part, productMetadataMap, pdpStacklineSku });
    case "data-search-query-result":
    case "tool-route_to_support":
    case "tool-search_faq":
    case "tool-escalate_to_human_support":
    case "tool-ask_user_for_information":
    case "tool-query_knowledge_base":
      return null;
    default:
      return null;
  }
}
export {
  ConciergePartItem
};
//# sourceMappingURL=ConciergePartItem.js.map
